import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const MinLengthValidator: (minLength: number, errorMessage: string) => FormValidator = (
  minLength: number,
  errorMessage: string
) => {
  return async (value: string): Promise<ValidationResult> => {
    if (value === undefined || value === null || value.length < minLength) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    return { valid: true };
  };
};
